import React from "react";
import IULEstimatorForm from "./IULEstimator";
import { getQueryStringValue } from "../../../utils/queryString";
import { useActions } from "../../../actions";
import * as Actions from "../../../actions/verify";
import { connect, useSelector } from "react-redux";


import { RootState } from "../../../reducers";
import { Strategy } from "../../../model/account";
import { useHistory } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Container, Grid, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Button from "@material-ui/core/Button";
import { makeStyles, Theme } from "@material-ui/core/styles";
import GreenArrow from "./Images/GreenArrow.svg";
import { LandingLayout } from "../index";
import { noop } from "../../../utils/commonUtils";
import useQueryString from "../../../hooks/useQueryString";

type Props = ReturnType<typeof mapStateToProps>;

const useStyles = makeStyles((theme: Theme) => ({
    headerActions: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(6),
    },
    enrollButton: {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        padding: "12px 35px",
        borderRadius: 50,
        fontWeight: 700,
        fontSize: "1rem",
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
        },
    },
    scrollPrompt: {
        display: "flex",
        alignItems: "center",
        fontSize: 24,
        fontWeight: 500,
        color: "rgb(0, 168, 107)",
    },
    scrollIconWrapper: {
        width: "60px",
        height: "60px",
        margin: "0 15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    mainTitle: {
        margin: 30,
    },
    highlight: {
        color: "rgb(0, 168, 107)",
    },
    subheading: {
        margin: "20px auto 40px",
        lineHeight: 1.6,
    },
    disclaimer: {
        fontStyle: "italic",
        color: "#5f6368",
    },
    qualificationItem: {
        textAlign: "center",
        padding: theme.spacing(2),
    },
    checkIcon: {
        fontSize: "3.5rem", // Larger icon size
        marginBottom: theme.spacing(1.5),
    },
    checkIconRed: {
        color: theme.palette.error.main,
    },
    checkIconYellow: {
        color: theme.palette.warning.main,
    },
    checkIconGreen: {
        color: theme.palette.success.main,
    },
    qualificationText: {
        color: "#3c4043",
        fontSize: "1rem",
        lineHeight: 1.5,
    },
    turbochargeButton: {
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
        padding: "15px 45px",
        borderRadius: 50,
        fontWeight: 700,
        fontSize: "1.1rem",
        marginTop: theme.spacing(4),
        "&:hover": {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.common.white,
        },
    },
}));



const IULEstimatWrap: React.FC<Props> = (props: ReturnType<(state: RootState) => { firstName: string | undefined; lastName?: string; role: number | undefined; verifiedInvite: boolean | undefined; checked: boolean | undefined; strategy: Strategy | undefined; updated: boolean | undefined }> & { children?: React.ReactNode }) => {
    const verifyActions = useActions(Actions);
    const classes = useStyles();
    const [stepperCurrentState, getStepperCurrentState] = React.useState<any>([]);
    const [illustrationId, setIllustrationId] = React.useState<any>();
    const inviteToken = getQueryStringValue("token");
    const [token, setToken] = React.useState<any>(inviteToken);
    const verifyInviteData = useSelector((state: RootState) => state.verify);

    const [progress, setProgress] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const history = useHistory();
    const TMClick = () => {
        window.scrollTo(0, 0);
        history.push(`/iul/turbocharge-iul/${token}`);
    };
    React.useEffect(() => {
        async function vfAccount() {
            await verifyActions.verifyAccount(inviteToken);
        }
        vfAccount();
    }, []);

    const PCClick = () => {
        window.scrollTo(0, 0);
        history.push(`/accept/invitation/${token}`);
    };

    React.useEffect(() => {
        if (props.checked && !props.verifiedInvite) {
            setProgress(false);
            setChecked(true);
        } else if (!props.checked) {
            setProgress(true);
            setChecked(false);
        } else if (props.verifiedInvite) {
            setProgress(false);
            setChecked(false);
        }
    }, [props]);

    if (progress) {
        return (
                <div>
                    <CircularProgress/>
                    <Typography>Verifying Link</Typography>
                </div>
        );
    }

    if (checked) {
        return (
                <div>
                    <Typography component="h2">Please contact site administrator. Link is invalid or
                        expired</Typography>
                </div>
        );
    }

    return (
            <LandingLayout>
                <Container maxWidth="lg" style={{ padding: "40px 0" }}>
                <Grid container spacing={2} alignItems="center" justify="center">
                    <Grid item xs={12} md={8} alignItems="center">
                        <Typography variant="h1" align="center">Estimate your potential
                            <span style={{ color: "#007BFF" }}>IUL benefits</span>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        {
                                verifyInviteData && verifyInviteData.id &&
                                <IULEstimatorForm
                                        getStepperCurrentState={getStepperCurrentState}
                                        setIllustrationId={setIllustrationId}
                                        verifyInviteData={verifyInviteData}
                                />
                        }
                    </Grid>
                    <Grid item xs={12} md={3} style={{ textAlign: "right" }}>
                        <Button variant="outlined" color="primary" onClick={PCClick}>
                            Enroll Now
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className={classes.scrollPrompt}>
                            <div className={classes.scrollIconWrapper}>
                                <img width="160px" src={GreenArrow} alt={"scroll-icon"} />
                            </div>
                            <span>OR KEEP SCROLLING TO SEE HOW YOU CAN TURBOCHARGE YOUR BENEFITS</span>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={3} justify="center" >
                            <Grid item xs={12} md={8} alignItems="center">
                                <Typography variant="h1" className={classes.mainTitle} component="h1"
                                            align="center">
                                    Want to <span className={classes.highlight}>turbocharge</span> your IUL? See if
                                    you
                                    qualify.
                                </Typography>
                                <Typography variant="subtitle1" className={classes.subheading} component="p">
                                    If you qualify, our leverage booster can help you multiply your cash value
                                    growth. <span
                                        className={classes.disclaimer}>*minimums do apply</span>
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <div className={classes.qualificationItem}>
                                            <CheckCircleIcon
                                                    className={`${classes.checkIcon} ${classes.checkIconRed}`} />
                                            <Typography className={classes.qualificationText}>You are between the
                                                ages
                                                of
                                                18-65</Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className={classes.qualificationItem}>
                                            <CheckCircleIcon
                                                    className={`${classes.checkIcon} ${classes.checkIconYellow}`} />
                                            <Typography className={classes.qualificationText}>Your combined
                                                household
                                                income
                                                is
                                                at least $100k</Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <div className={classes.qualificationItem}>
                                            <CheckCircleIcon
                                                    className={`${classes.checkIcon} ${classes.checkIconGreen}`} />
                                            <Typography className={classes.qualificationText}>You are in average or
                                                good
                                                health</Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Button variant="outlined" color="primary" className="mt30 mb20 float-right" onClick={TMClick}>
                                    Yes, turbocharge me!
                                </Button>
                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>
            </Container>
            </LandingLayout>
    );

};


function mapStateToProps(state: RootState) {
    return {
        verifiedInvite: state.verify.verifiedInvite,
        checked: state.verify.checked,
        updated: state.verify.updated,
        firstName: state.verify.firstName,
        lastName: state.verify.lastName,
        role: state.verify.role,
        strategy: state.verify.strategy,
    };
}

export default connect(mapStateToProps)(IULEstimatWrap);